<template>
  <section v-if="event">
    <b-img fluid center :src="poster.url" v-if="poster"></b-img>
    <hr v-if="poster">
    <p>
      <strong>{{ $t('event.detail.label.name') }}：</strong><br>
      {{ event.name }}
    </p>
    <p>
      <strong>{{ $t('event.detail.label.start-date') }}：</strong><br>
      {{ event.start_date.slice(0, 10) }}
      <span v-if="event.start_date_note">{{ event.start_date_note }}</span>
    </p>
    <p>
      <strong>{{ $t('event.detail.label.end-date') }}：</strong><br>
      {{ event.end_date.slice(0, 10) }}
      <span v-if="event.end_date_note">{{ event.end_date_note }}</span>
    </p>
    <p>
      <strong>{{ $t('event.detail.label.venue') }}：</strong><br>
      <span>財團法人佛陀教育基金會 華藏教學園區<br>[新北市深坑區阿柔里5鄰大崙尾9號]</span>
    </p>
    <p v-if="event.detail.target_audience">
      <strong>{{ $t('event.detail.registration.label.target-audience') }}：</strong><br>
      {{ event.detail.target_audience }}
    </p>
    <p v-if="event.detail.leader_intro">
      <strong>{{ $t('event.detail.registration.label.leader-intro') }}：</strong><br>
      <span v-html="event.detail.leader_intro"></span>
    </p>
    <p v-if="event.detail.event_content">
      <strong>{{ $t('event.detail.registration.label.content') }}：</strong><br>
      <span v-html="event.detail.event_content"></span>
    </p>
    <p v-if="event.detail.registration_date">
      <strong>{{ $t('event.detail.registration.label.registration-date') }}：</strong><br>
      {{ event.detail.registration_date }}
    </p>
    <p v-if="event.detail.registration_method">
      <strong>{{ $t('event.detail.registration.label.registration-method') }}：</strong><br>
      <span v-html="event.detail.registration_method"></span>
    </p>
    <p v-if="event.detail.registration_fee">
      <strong>{{ $t('event.detail.registration.label.registration-fee') }}：</strong><br>
      {{ event.detail.registration_fee }}
    </p>
    <p v-if="event.detail.quota">
      <strong>{{ $t('event.detail.registration.label.quota') }}：</strong><br>
      {{ event.detail.quota }}
    </p>
    <p v-if="event.detail.shuttle_info">
      <strong>{{ $t('event.detail.registration.label.shuttle-info') }}：</strong><br>
      <span v-html="event.detail.shuttle_info"></span>
    </p>
    <p v-if="event.detail.self_check_in_info">
      <strong>{{ $t('event.detail.registration.label.self-check-in-info') }}：</strong><br>
      <span v-html="event.detail.self_check_in_info"></span>
    </p>
    <p v-if="event.detail.note">
      <strong>{{ $t('event.detail.registration.label.note') }}：</strong><br>
      <span v-html="event.detail.note"></span>
    </p>
    <b-button
      size="lg"
      variant="primary"
      target="_blank"
      :to="{ name: 'event-registration-form', params: { id: event.id } }"
      v-if="show_register_button"
    >{{ $t('event.detail.registration.button.register.label') }}</b-button>
    <b-button
      size="lg"
      variant="primary"
      target="_blank"
      :href="registration_form.url"
      v-if="registration_form"
    >{{ $t('event.detail.registration.button.registration-form-download.label') }}</b-button>
    <social-sharing-button-toolbar
      class="mt-3"
      :title="social_sharing_title"
      :to="social_sharing_route"
    ></social-sharing-button-toolbar>
  </section>
</template>

<script>
import Vue from 'vue'

import { ButtonPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'

import i18n from '@/plugins/i18n.js'

Vue.use(ButtonPlugin)
Vue.use(ImagePlugin)

export default {
  i18n,
  name: 'event-registration-info',
  props: {
    event: {
      type: Object,
      require: true
    },
    show_register_button: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 
    }
  },
  computed: {
    poster() {
      return this.event.detail.attachments.find(item => item.category === 'poster')
    },
    registration_form() {
      return this.event.detail.attachments.find(item => item.category === 'registration-form')
    },
    social_sharing_title() {
      return `${this.event.name} 報名簡章`
    },
    social_sharing_route() {
      return { name: 'event-registration-info', params: { id: this.event.id } }
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    if (this.event && this.event.id) {
      gtag('event', `browse event`, {
        code: this.event.id,
        name: this.event.name,
      })
    }
  },
  components: {
    SocialSharingButtonToolbar
  }  
}
</script>